module.exports = __webpack_public_path__ + "static/media/39_Secretariat_Cell.32ad8b89.JPG";